import ServiceGraphQL from 'src/service/gql-service';
import { whoami } from 'src/graphql';

const serviceGraphQL = new ServiceGraphQL();

export const Whoami = () => {
  const params = {
    query: whoami.QUERY
  };
  return serviceGraphQL
    .post(params)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      throw err;
    });
};
